import {
    WithProfileId,
    isEnterpriseProfileData,
    isIntegrationProfileData,
    isPersonalProfileData,
} from '@mews-commander/types';
import { WithThreadId } from '../../types';
import { useProfileData } from '../../useProfileData';
import { MewsProfileAvatarProps } from './types';
import { IntegrationProfileAvatar, UserProfileAvatar, UserProfileAvatarProps } from './components';

type ProfileAvatarProps = MewsProfileAvatarProps &
    Pick<UserProfileAvatarProps, 'useBigEnterpriseImage'> &
    WithThreadId &
    WithProfileId;

const ProfileAvatar = ({ threadId, useBigEnterpriseImage, profileId, ...other }: ProfileAvatarProps) => {
    const profileData = useProfileData(profileId);

    if (!profileData) {
        return null;
    }

    if (isEnterpriseProfileData(profileData) || isPersonalProfileData(profileData)) {
        return (
            <UserProfileAvatar
                userId={profileData.value.userId}
                isEmployee={isEnterpriseProfileData(profileData)}
                useBigEnterpriseImage={useBigEnterpriseImage}
            />
        );
    }

    if (isIntegrationProfileData(profileData)) {
        return <IntegrationProfileAvatar threadId={threadId} {...other} />;
    }

    return null;
};

export default ProfileAvatar;
